import { useProjectStore } from "../state/projectStore";
import { useKeyStore } from "../state/keyStore";
import { useUi } from "../state/ui";
import { ChordGrid } from "./ChordGrid";
import { PdfScore } from "./PdfScore";
import { AdSlot } from "./AdSlot";
import { ExportMenu } from "./ExportMenu";
import { AD_SLOTS } from "../ads/adsense";
import { ScoreLinesIcon, ChordIcon, InfoIcon } from "./icons";
import { settingLabel } from "./keyText";
import { useT } from "../i18n";

// The score section with a view toggle: lead-sheet chord grid ⇄ the user's own PDF sheet.
// Export applies to the chord chart only, so it is hidden in the PDF view.
export function ScoreSection() {
  const t = useT();
  const hasChart = useProjectStore((s) => s.chartMeasures.length > 0);
  const songKey = useProjectStore((s) => s.analysis?.key);
  const transpose = useKeyStore((s) => s.transpose);
  const capo = useKeyStore((s) => s.capo);
  const view = useUi((s) => s.scoreView);
  const setView = useUi((s) => s.setScoreView);

  // nothing analyzed yet → a quiet prompt instead of an endless loading spinner
  if (!hasChart) {
    return (
      <section className="section">
        <h2>{t("score.title")}</h2>
        <div className="score-empty">{t("score.empty")}</div>
      </section>
    );
  }

  const keyChanged = transpose !== 0 || capo > 0;
  return (
    <section className="section score-section" id="score">
      <div className="section-head score-head">
        <h2>{t("score.title")}</h2>
        <div className={"score-tools" + (view === "chord" ? "" : " solo")}>
          {view === "chord" && <ExportMenu />}
          <div className="view-toggle" role="group">
            <button className={"view-seg" + (view === "chord" ? " on" : "")} onClick={() => setView("chord")} title={t("score.chord")} aria-pressed={view === "chord"}>
              <ChordIcon size={14} /><span>{t("score.chord")}</span>
            </button>
            <button className={"view-seg" + (view === "score" ? " on" : "")} onClick={() => setView("score")} title={t("score.tab")} aria-pressed={view === "score"}>
              <ScoreLinesIcon size={14} /><span>{t("score.tab")}</span>
            </button>
          </div>
        </div>
      </div>
      {view === "score" && keyChanged && songKey && (
        <div className="key-pdf-note">
          <InfoIcon size={16} />
          <span>{t("key.pdf_note", { s: settingLabel(t, { tonic: songKey.tonic, quality: songKey.quality }, { transpose, capo }) })}</span>
          <button onClick={() => setView("chord")}>{t("score.chord")}</button>
        </div>
      )}
      <div className="score-layout">
        <div className="score-main">
          {view === "chord" ? <ChordGrid /> : <PdfScore />}
        </div>
        {/* banner beside the chart (in-app only; renders nothing until AdSense is configured) */}
        <AdSlot slot={AD_SLOTS.scoreRail} className="ad-rail" />
      </div>
    </section>
  );
}
